export const distinct = (value: any, index: number, array: any[]) => {
    return array.indexOf(value) === index
}